var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payout-settings"},[_c('AccountDetails'),_c('Swish',{staticClass:"m-t-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }